import React from "react";
import { Box, Stack, Text, TextLink } from "@origin-digital/ods-core";
import { content } from "./AIAnswer.content";

const { disclaimer } = content;

export const AIAnswerDisclaimer: React.FC = () => (
  <Box
    display="flex"
    alignItems="center"
    gap="xsmall"
    data-id="ai-answer-disclaimer"
  >
    <Stack space="none">
      <Text variant="body-small" tone="neutralLight" weight="regular">
        {disclaimer.lead}
        <TextLink
          href={disclaimer.linkHref}
          data-id="ai-answer-disclaimer-privacy-link"
          target="_blank"
          domProps={{ rel: "noopener noreferrer" }}
        >
          {disclaimer.linkLabel}
        </TextLink>
        {disclaimer.trail}
      </Text>
    </Stack>
  </Box>
);
